import assignIn from 'lodash/assignIn';
import toString from 'lodash/toString';
import type { RestSummaryRuleSet, RestSummaryResponse } from '../../../rest/types';

const castRuleSetIdsToStrings = (ruleSets: RestSummaryRuleSet[]): RestSummaryRuleSet[] =>
	ruleSets.map((ruleSet) => assignIn(ruleSet, { id: toString(ruleSet.id) }));

export const preprocessSummary = (
	restSummaryResponse: RestSummaryResponse,
): RestSummaryResponse => {
	const processedRuleSets = castRuleSetIdsToStrings(restSummaryResponse.ruleSets);
	return {
		ruleSets: processedRuleSets,
		projectRunAsUserSettings: restSummaryResponse.projectRunAsUserSettings,
		blueprints: restSummaryResponse.blueprints,
	};
};
